import React from "react";
import PathHelper from "../../utils/path-helper";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { APP_NAVIGATION } from "../../utils/constants";
import { Link } from "react-router-dom";

const ResumeBuildFooter = ({ privacyPolicy, termsOfUse, contactUs }) => {
  const { t } = useTranslation();
  let pathRedirectHome = PathHelper(APP_NAVIGATION.RHOM, false);

  const location = useLocation();
  const navigate = useNavigate();

  const redirectHomeHandle = () => {
    navigate(pathRedirectHome.next);
  };

  return (
    <>
      <footer className="footer bg-gray-800 text-white py-10 w-full">
        <div className="container mx-auto text-sm flex flex-col lg:flex-row items-center justify-between">
          <div className="footer--logo mb-4 lg:mb-0">
            {location.pathname.includes("checkout") ? (
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/static/images/resumebuild-white.svg"
                }
                alt="ResumeBuild"
              />
            ) : (
              <a href={pathRedirectHome.next}>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/static/images/resumebuild-white.svg"
                  }
                  alt="ResumeBuild"
                />
              </a>
            )}
          </div>
          <div className="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-16 mb-4 lg:mb-0">
            <a
              id="anchorContactUs"
              href={contactUs}
              title={t("footer.rb.contact_us")}
              target="_blank"
              className="footer-link"
            >
              {t("footer.rb.contact_us")}
            </a>
            <a
              id="anchorPrivacy"
              href={privacyPolicy}
              title={t("footer.privacy_policy")}
              target="_blank"
              className="footer-link"
            >
              {t("footer.rb.privacy_policy")}
            </a>
            <a
              id="anchorTemsNCondition"
              href={termsOfUse}
              title={t("footer.rb.terms_condition")}
              target="_blank"
              className="footer-link"
            >
              {t("footer.rb.terms_condition")}
            </a>

            {/* <Link className="footer-link" to={contactUs} title={t("footer.contact_us")}>
              {t("footer.rb.contact_us")}
            </Link>
            <Link className="footer-link" to={privacyPolicy} title={t("footer.privacy_policy")}>
              {t("footer.rb.privacy_policy")}
            </Link>
            <Link className="footer-link" to={termsOfUse} title={t("footer.rb.terms_condition")}>
              {t("footer.rb.terms_condition")}
            </Link> */}
          </div>
          <div className="text-center  lg:text-left">
            <span className="footer--copyright">
              © {new Date().getFullYear()}. {t("footer.rb.workSimpli_software")}
              <br />
              {t("footer.rb.all_rights_reserved")}
            </span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default ResumeBuildFooter;
